import React from 'react'

/**
 * Button — primary action control. Notion-style: 32px tall, 6px radius,
 * medium weight, instant color transitions. Icons go inside as children.
 */
export function Button({
  variant = 'primary',
  size = 'md',
  block = false,
  type = 'button',
  className = '',
  children,
  ...rest
}) {
  const cls = [
    'btn',
    `btn-${variant}`,
    size === 'sm' && 'btn-sm',
    block && 'btn-block',
    className
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button type={type} className={cls} {...rest}>
      {children}
    </button>
  )
}
